import React from 'react';
import './AvatarCard.scss';
import { FaRegHeart, FaCheckCircle } from 'react-icons/fa';

/**
 * AvatarCard displays a user avatar with optional favorite and verified badges.
 * Renders a colored placeholder with initial if imageUrl is empty.
 * @param {object} props
 * @param {string} props.id - Unique user ID for generating placeholder color
 * @param {string} props.imageUrl - Source URL for the avatar image
 * @param {string} props.alt - Alt text / user name for the avatar
 * @param {boolean} [props.isFavorite=false]
 * @param {boolean} [props.isVerified=false]
 * @param {function} [props.onClick]
 */
const AvatarCard = ({ uid, imageUrl, name, isFavorite = false, isVerified = false, onClick }) => {
  // Generate a consistent color per user ID  
  const getRandomColor = (id) => {
    let hash = 0;
    for (let char of id) {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  // Get initial letter from alt (assumed name)
  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '');

  const hasImage = imageUrl && imageUrl.trim() !== '';

  return (
    <div className="avatar-card" onClick={onClick}>
      <div className="avatar-wrapper">
        {hasImage ? (
          <img src={imageUrl} alt={name} className="avatar-img" />
        ) : (
          <div
            className="avatar-img placeholder"
            style={{ backgroundColor: getRandomColor(uid) }}
          >
            <span className="initial">{getInitial(name)}</span>
          </div>
        )}
        {isVerified && <FaCheckCircle className="verified-badge" />}
        <div className="heart-icon-wrapper">
          <FaRegHeart className={`heart-icon ${isFavorite ? 'favorited' : ''}`} />
        </div>
      </div>
    </div>
  );
};

export default AvatarCard;
